var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32719_41350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6C11.25 3.1005 8.8995 0.75 6 0.75C3.10051 0.75 0.75 3.1005 0.75 6C0.75 8.89949 3.10051 11.25 6 11.25C8.8995 11.25 11.25 8.89949 11.25 6Z",
    fill: "url(#paint0_linear_32719_41350)",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.25V3.74999V8.25Z",
    fill: "url(#paint1_linear_32719_41350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.25V3.74999",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6L8.25 6L3.75 6Z",
    fill: "url(#paint2_linear_32719_41350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6L8.25 6",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32719_41350",
    x1: 6,
    y1: 0.75,
    x2: 6,
    y2: 11.0715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A151F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32719_41350",
    x1: 6.5,
    y1: 3.74999,
    x2: 6.5,
    y2: 8.17351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A151F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32719_41350",
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 5.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A151F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32719_41350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.13c2394ed5bfbbf86990c330cdb57eee.svg";
export { ForwardRef as ReactComponent };